import { StyledContent } from '@/components/styles';
import { Picture } from '@/components';

export default function Certificate({ certificate }) {
  const { title, image, content } = certificate.data;
  return (
    <StyledContent.Certificate>
      <Picture {...image} />
      <StyledContent.CertificateName>{title}</StyledContent.CertificateName>
      {content && (
        <StyledContent.CertificateText>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: content }} />
        </StyledContent.CertificateText>
      )}
    </StyledContent.Certificate>
  );
}
